export const HOUSE_EDGE = 0.05;

export const MAX_ROWS_EASY = 9;
export const MAX_ROWS_HARD = 6;

export enum Pattern {
  EASY = 0,
  MEDIUM = 1,
  HARD = 2,
  EXPERT = 3,
  MASTER = 4,
}

export const PATTERN_MAP = {
  [Pattern.EASY]: {
    rows: MAX_ROWS_EASY,
    cols: 4,
  },
  [Pattern.MEDIUM]: {
    rows: MAX_ROWS_EASY,
    cols: 3,
  },
  [Pattern.HARD]: {
    rows: MAX_ROWS_EASY,
    cols: 2,
  },
  [Pattern.EXPERT]: {
    rows: MAX_ROWS_HARD,
    cols: 3,
  },
  [Pattern.MASTER]: {
    rows: MAX_ROWS_HARD,
    cols: 4,
  },
};

export const PATTERN_MINES: Record<Pattern, number> = {
  [Pattern.EASY]: 1,
  [Pattern.MEDIUM]: 1,
  [Pattern.HARD]: 1,
  [Pattern.EXPERT]: 2,
  [Pattern.MASTER]: 3,
} as const;

export const PATTERN_COLS: Record<Pattern, number> = {
  [Pattern.EASY]: 4,
  [Pattern.MEDIUM]: 3,
  [Pattern.HARD]: 2,
  [Pattern.EXPERT]: 3,
  [Pattern.MASTER]: 4,
} as const;
